<template>
  <div id="module-edit" class="modern-dialog">
    <v-card class="elevation-4" style="border-radius: 12px">
      <!-- Modern Header with Icon -->
      <div class="dialog-header">
        <div class="header-left">
          <div class="header-icon">
            <v-icon size="32">mdi-calendar-clock</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">{{ pageTitle }}</h2>
            <p class="header-subtitle">Select your preferred training date</p>
          </div>
        </div>
        <div class="header-actions">
          <v-btn
            icon
            @click="closePrompt"
            class="action-btn close-btn"
            title="Close"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Content Area -->
      <v-container class="content-area">
        <!-- Loading State -->
        <div class="d-flex justify-content-center align-items-center py-12" v-if="LoadingFlag">
          <div class="loading-spinner">
            <v-progress-circular
              indeterminate
              :size="50"
              :width="4"
              color="primary"
            ></v-progress-circular>
            <p class="mt-3">Loading...</p>
          </div>
        </div>

        <!-- Form Content -->
        <v-form
          v-if="!LoadingFlag"
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="submitForm"
        >
          <div class="form-section">
            <div class="form-section-title">
              <v-icon small class="mr-2">mdi-information-outline</v-icon>
              Date Selection
            </div>

            <v-row wrap class="form-row">
              <v-col cols="12" sm="8" lg="6" md="8" class="form-col">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="PreferredDate"
                      :rules="PreferredDateRules"
                      label="Preferred Training Date"
                      placeholder="Select date"
                      readonly
                      v-on="on"
                      outlined
                      dense
                      class="date-input"
                      prepend-icon="mdi-calendar-outline"
                      background-color="transparent"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="PreferredDate"
                    @input="menu1 = false"
                    color="primary"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- Information Display -->
            <div class="info-box" v-if="recordData.YearWiseLomId">
              <v-icon small color="info" class="mr-2">mdi-information</v-icon>
              <span class="info-text">
                Training ID: <strong>{{ recordData.YearWiseLomId }}</strong>
              </span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="button-group">
            <v-btn
              :disabled="!valid1"
              @click.prevent="submitForm"
              :loading="SubmitFlag"
              color="success"
              class="action-submit-btn"
              large
              elevation="2"
            >
              <v-icon left>mdi-check-circle-outline</v-icon>
              Submit
            </v-btn>
          </div>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    pageTitle: {
      required: true,
    },
    presidentDatePrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SubmitFlag: false,

      PreferredDate: "",
      PreferredDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      ResultFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearWiseLomId = this.recordData.YearWiseLomId;
        console.log({ YearWiseLomIdsss: YearWiseLomId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;
        this.CurrentYearId = CurrentJciYearId;

        this.ToDate = currentDate;

        this.GroupId = this.recordData.GroupId;
        this.GroupName = this.recordData.GroupName;
        this.GroupStatus = this.recordData.ActiveStatus;
      }
    },
  },
  mounted() {},
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");

      var tr = this.recordData;
      console.log({ tr });

      // this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "group_settings",
        Action: "edit",
      };
      // this.getPageDetails("PageInfo", {}, url1, condition1);
      var currentDate = this.getCurrentDate();
      this.PreferredDate = currentDate;
    },
    submitForm() {
      console.log("submitForm is called");

      var tr = this.recordData;
      console.log({ tr });

      var CategoryId = tr.CategoryId;
      console.log({ CategoryId });

      if (CategoryId > 0) {
        var upload = {
          UserInterface: CategoryId,
          PreferredDate: this.PreferredDate,
        };
        console.log({ upload });

        this.progessStart = 1;
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/suggest-date";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.progessStart = 0;
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (CategoryId < 0) {
          message += "LO Training category details invalid.";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
#module-edit {
  .modern-dialog {
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px 12px 0 0;
    color: white;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;

      .header-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        backdrop-filter: blur(10px);

        .v-icon {
          color: white !important;
        }
      }

      .header-text {
        .header-title {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          letter-spacing: -0.5px;
        }

        .header-subtitle {
          margin: 4px 0 0 0;
          font-size: 13px;
          opacity: 0.9;
          font-weight: 400;
        }
      }
    }

    .header-actions {
      display: flex;
      gap: 8px;

      .action-btn {
        background: rgba(255, 255, 255, 0.2) !important;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: scale(1.1);
        }

        &.close-btn {
          .v-icon {
            color: white !important;
          }
        }
      }
    }
  }

  .content-area {
    padding: 32px;
    min-height: 300px;

    .loading-spinner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;

      p {
        margin: 0;
        color: #667eea;
        font-weight: 500;
      }
    }

    .form-section {
      margin-bottom: 24px;

      .form-section-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid #f0f0f0;

        .v-icon {
          color: #667eea;
        }
      }

      .form-row {
        gap: 16px;

        .form-col {
          display: flex;
          flex-direction: column;

          .date-input {
            ::v-deep .v-input__control {
              .v-input__slot {
                border: 2px solid #e0e0e0 !important;
                border-radius: 8px !important;
                transition: all 0.3s ease;

                &:hover {
                  border-color: #667eea !important;
                  background: #f8f9ff !important;
                }

                &:focus,
                &:focus-within {
                  border-color: #667eea !important;
                }
              }
            }
          }
        }
      }

      .info-box {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
        border-left: 4px solid #667eea;
        border-radius: 8px;
        margin-top: 12px;
        font-size: 13px;

        .info-text {
          color: #424242;

          strong {
            color: #667eea;
            font-weight: 600;
          }
        }
      }
    }

    .button-group {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      padding-top: 24px;
      border-top: 1px solid #f0f0f0;

      .action-submit-btn {
        min-width: 160px;
        border-radius: 8px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        transition: all 0.3s ease;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
        }

        .v-icon {
          margin-right: 8px;
        }
      }
    }
  }

  .notes {
    color: red;
    font-size: 18px;
    font-weight: 500;
    line-height: 2;
  }
  .notes-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }
  .notes-content {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }
}
</style>